import GenericReportMobile from '../_partials/GenericReportMobile';
import { useTranslation } from 'react-i18next';
import SoldSubscriptionsTableRowHeadingMobile from './SoldSubscriptionsTableRowHeadingMobile';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import { getDeviationPrice } from '@wix/da-shared-react/pkg/utils/deviations';
import { PapiDeviation } from '@wix/da-papi-types';

import s from './SoldSubscriptionsMobile.scss';

export default function SoldSubscriptionsMobile() {
  const { t } = useTranslation();

  const columns = [
    {
      key: 'deviation',
      label: t('studio.reports.common.table.header.price'),
      className: s['products-sold'],
      format: (deviation: PapiDeviation) =>
        deviation && formatDollars(getDeviationPrice(deviation).dollarsPrice),
    },
    {
      key: 'uniqueCustomers',
      label: t(
        'studio.reports.section.soldSubscriptions.table.header.uniqueCustomers'
      ),
    },
    {
      key: 'salesVolume',
      label: t('studio.reports.common.table.header.salesVolume'),
      format: formatDollars,
    },
  ];

  return (
    <GenericReportMobile
      reportType="soldSubscriptions"
      headingKey="studio.reports.section.soldSubscriptions.title"
      descriptionKey="studio.reports.section.soldSubscriptions.description"
      descriptionTranslationOptions={{
        postProcess: ['reactPostprocessor'],
        learnMoreLink: (
          <a
            className="text-link-level-2-tertiary"
            href={t(
              'studio.reports.section.soldSubscriptions.description.learnMoreLink.url'
            )}
          >
            {t(
              'studio.reports.section.soldSubscriptions.description.learnMoreLink.text'
            )}
          </a>
        ),
      }}
      columns={columns}
      RowHeading={SoldSubscriptionsTableRowHeadingMobile}
      showTotal
    />
  );
}
